// extracted by mini-css-extract-plugin
export var activeTab = "TabbedData-module--activeTab--dfad8";
export var inactiveTab = "TabbedData-module--inactiveTab--ba36c";
export var subTabcontent = "TabbedData-module--subTabcontent--9f955";
export var tabList = "TabbedData-module--tabList--093ae";
export var title = "TabbedData-module--title--24b27";
export var wrapper = "TabbedData-module--wrapper--41937";